import Login from './login';
import LoginFaq from './login/login.faq';
import LoginSecurity from './login/login.security';
import LoginContactUs from './login/login.contact.us';

export default {
  Login,
  LoginFaq,
  LoginSecurity,
  LoginContactUs
};
